import styled from 'styled-components';

interface HeaderContainerProps {
  justifyContent?: string,
}

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: ${({ justifyContent }: HeaderContainerProps) => justifyContent || 'flex'};
`;

export const CloseIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: rgba(136, 0, 255, 0.04);
  border-radius: 50%;
  cursor: pointer;
`;


export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
`;

export const Title = styled.div`
  font-size: 32px;
  color: black;
`;
export const SubTitle = styled.div`
  font-size: 18px;
  color: #707070;
`;

export const Body = styled.div`
  font-size: 16px;
  color: #707070;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
`;

export const BackButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(136, 0, 255, 0.04);
  cursor: pointer;
`;

export const BackArrowImage = styled.img`
  width: 24px;
  height: 24px;
`;